import React from 'react'
import "./copyright.scss"
export default function Copyright() {
    return (
        <div className="row noSpace copyright-row mx-0">
            <p className="mb-0 py-3">Copyright © 2025 Ecofroz</p>
        </div>
    )
}
